/* Alux · centavos pequeños y alineados arriba en todos los precios */
(function(){
  var SEL='.price-item,.price,.totals__total-value,.cart-item__price-wrapper,.cart-item__totals,.product-option,.quantity__rules,.volume-pricing-list,.ax-card__price,.ax-hero__caption,.ax-card__badge,.ax-buy,.cart-drawer__footer,.cart__footer';
  var RE=/(\$\s?\d{1,3}(?:[.,]\d{3})*)([.,])(\d{2})(?!\d)/;
  function fmt(node){
    if(node.nodeType!==3)return;
    var p=node.parentNode;if(!p||p.closest('sup,script,style,input,textarea'))return;
    var m=RE.exec(node.nodeValue);if(!m)return;
    var before=node.nodeValue.slice(0,m.index)+m[1];
    var sup=document.createElement('sup');sup.className='ax-cents';sup.textContent=m[2]+m[3];
    var after=document.createTextNode(node.nodeValue.slice(m.index+m[0].length));
    node.nodeValue=before;p.insertBefore(sup,node.nextSibling);p.insertBefore(after,sup.nextSibling);
    fmt(after);
  }
  function scan(root){
    var els=root.nodeType===1&&root.matches(SEL)?[root]:[];
    if(root.querySelectorAll)els=els.concat(Array.prototype.slice.call(root.querySelectorAll(SEL)));
    els.forEach(function(el){var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),t,list=[];while((t=w.nextNode()))list.push(t);list.forEach(fmt);});
  }
  function ready(){scan(document.body);new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)scan(n);else if(n.nodeType===3&&n.parentNode)scan(n.parentNode);});if(m.type==='characterData'&&m.target.parentNode)scan(m.target.parentNode);});}).observe(document.body,{childList:true,subtree:true,characterData:true});}
  if(document.body)ready();else document.addEventListener('DOMContentLoaded',ready);
})();
